<!-- 需求耗时分布 -->
<template>
  <div>
    <a-card size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">需求耗时分布</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>时间: 需求耗时分布</p>
            <p>数据百分比为100: 取每个阶段的平均耗时</p>
            <p>数据百分比不为100: 取对应数据P线的那条数据</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <div :id="chartId" :style="{ height: height, width: width }" />
    </a-card>
    <BrTimeDistributionDetailModal ref="brTimeDistributionDetailModalRef" />
  </div>
</template>
<script>
import BrTimeDistributionDetailModal from './BrTimeDistributionDetailModal';
export default {
  components: { BrTimeDistributionDetailModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '500px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      showModal: 'person',
      chartId: 'task-take-time-distribution',
      myChart: null,
      titleDict: {},
      tableData: [],
      index: 0,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
          // formatter: params => {
          //   const dataIndex = params[0].dataIndex;
          //   let formatter = '<div><b>' + params[0].name + '</b><br>';
          //   formatter += `${params[0].marker} ${params[0].seriesName}: <span style="color: #5A6FC0;"><b>${params[0].value}</b></span> 小时 <br>`;
          //   formatter += `${params[1].marker} ${params[1].seriesName}: <span style="color: #00B83F;"><b>${params[1].value}</b></span> 小时 <br>`;
          //   formatter += `${params[2].marker} ${params[2].seriesName}: <span style="color: #F2CA6B;"><b>${params[2].value}</b></span> 小时 <br>`;
          //   formatter += `${params[3].marker} ${params[3].seriesName}: <span style="color: #5A6FC0;"><b>${params[3].value}</b></span> 小时 <br>`;
          //   formatter += `${params[4].marker} ${params[4].seriesName}: <span style="color: #00B83F;"><b>${params[4].value}</b></span> 小时 <br>`;
          //   formatter += `${params[5].marker} ${params[5].seriesName}: <span style="color: #F2CA6B;"><b>${params[5].value}</b></span> 小时 <br>`;
          //   formatter += '</div>';
          //   return formatter;
          // }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: {},
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18,
            startValue: 0,
            endValue: 14
          }
        ]
      },
      xAxisData: [],
      series: []
    };
  },
  watch: {
    filterForm() {
      // this.getData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.myChart.resize();
        });
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    this.myChart = echarts.init(document.getElementById(this.chartId));
    const self = this;
    this.myChart.getZr().on('click', param => {
      const pointInPixel = [param.offsetX, param.offsetY];
      // 判断给定的点是否在指定的坐标系或者系列上
      if (self.myChart.containPixel('grid', pointInPixel)) {
        // 获取到点击的 x轴 下标  转换为逻辑坐标
        const index = self.myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
        self.onDetail(index);
      }
    });
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    getData(buildTableData, tableData) {
      this.tableData = tableData;
      const x_axis = [];
      const timeList_135 = [];
      const timeList_136 = [];
      const timeList_137 = [];
      const timeList_138 = [];
      const timeList_139 = [];
      const timeList_140 = [];
      buildTableData.forEach(el => {
        x_axis.push(el.months);
        timeList_135.push(el['135'] || 0);
        timeList_136.push(el['136'] || 0);
        timeList_137.push(el['137'] || 0);
        timeList_138.push(el['138'] || 0);
        timeList_139.push(el['139'] || 0);
        timeList_140.push(el['140'] || 0);
      });
      this.option.xAxis.data = x_axis;
      this.option.series = [
        {
          type: 'bar',
          name: '需求问答中-待需求方案',
          data: timeList_135,
          stack: 'cost',
          label: {
            show: true
          }
        },
        {
          type: 'bar',
          name: '待需求方案-待开发',
          data: timeList_136,
          stack: 'cost',
          label: {
            show: true
          }
        },
        {
          type: 'bar',
          name: '待开发-开发中',
          data: timeList_137,
          stack: 'cost',
          label: {
            show: true
          }
        },
        {
          type: 'bar',
          name: '开发中-待验收',
          data: timeList_138,
          stack: 'cost',
          label: {
            show: true
          }
        },
        {
          type: 'bar',
          name: '待验收-验收中(天)',
          data: timeList_139,
          stack: 'cost',
          label: {
            show: true
          }
        },
        {
          type: 'bar',
          name: '验收中-已交付(天)',
          data: timeList_140,
          stack: 'cost',
          label: {
            show: true
          }
        }
      ];
      this.drawChart();
    },

    onDetail(index) {
      this.index = index;
      const indexData = this.data[index];
      if (indexData && indexData.months) {
        const tableData = this.tableData.filter(item => item.months === indexData.months);
        console.log(tableData);
        this.$refs.brTimeDistributionDetailModalRef.open(tableData);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
</style>
